import { render, staticRenderFns } from "./insurer.vue?vue&type=template&id=d4f861bc&scoped=true&"
import script from "./insurer.vue?vue&type=script&lang=js&"
export * from "./insurer.vue?vue&type=script&lang=js&"
import style0 from "./insurer.vue?vue&type=style&index=0&id=d4f861bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f861bc",
  null
  
)

export default component.exports